export const address = {
	type: 'object',
	properties: {
		country: {
			type: 'string'
		},
		city: {
			type: 'string'
		},
		street: {
			type: 'string'
		},
		zip: {
			type: 'string'
		}
	}
};
